export const ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  PRACTICE_ADMIN: "PRACTICE_ADMIN",
  PRACTICE_FINANCE: "PRACTICE_FINANCE",
  COMPANY_ADMIN: "COMPANY_ADMIN",
  COMPANY_USER: "COMPANY_USER",
  DAO_ADMIN: "DAO_ADMIN",
  DAO_FINANCE: "DAO_FINANCE",
  DAO_USER: "DAO_USER"
};

const {
  COMPANY_ADMIN,
  COMPANY_USER,
  DAO_ADMIN,
  DAO_FINANCE,
  DAO_USER,
  PRACTICE_ADMIN,
  PRACTICE_FINANCE,
  SUPER_ADMIN
} = ROLES;

export const Permissions = {
  "bulkpublishing.read": [
    SUPER_ADMIN,
    PRACTICE_FINANCE,
    PRACTICE_ADMIN,
    COMPANY_ADMIN
  ],
  "workspace.read": [
    SUPER_ADMIN,
    PRACTICE_FINANCE,
    PRACTICE_ADMIN,
    DAO_ADMIN,
    DAO_FINANCE,
    DAO_USER,
    COMPANY_ADMIN,
    COMPANY_USER
  ],
  "workspace.create": [SUPER_ADMIN],
  "workspace.update": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN
  ],
  "workspace.delete": [SUPER_ADMIN],
  "workspace.summary": [
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    DAO_FINANCE
  ],
  "mandateType.read": [PRACTICE_ADMIN, PRACTICE_FINANCE],
  "mandateType.create": [],
  "mandateType.update": [],
  "mandateType.delete": [],
  "mandate.read": [PRACTICE_ADMIN, PRACTICE_FINANCE],
  "mandate.create": [PRACTICE_ADMIN, PRACTICE_FINANCE],
  "mandate.update": [PRACTICE_ADMIN, PRACTICE_FINANCE],
  "mandate.delete": [PRACTICE_ADMIN, PRACTICE_FINANCE],
  "mandate.current": [
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_FINANCE,
    DAO_ADMIN,
    DAO_USER,
    COMPANY_ADMIN,
    COMPANY_USER
  ],
  "document.read": [
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "document.upload": [
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_FINANCE,
    DAO_ADMIN,
    DAO_USER,
    COMPANY_ADMIN,
    COMPANY_USER
  ],
  "document.update": [
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "document.download": [
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "document.delete": [
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "document.single": [
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "document.sync": [
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.read": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_FINANCE,
    DAO_ADMIN,
    DAO_USER,
    COMPANY_ADMIN,
    COMPANY_USER
  ],
  "company.create": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_FINANCE,
    DAO_ADMIN
  ],
  "company.update": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.delete": [SUPER_ADMIN, PRACTICE_ADMIN, PRACTICE_FINANCE, DAO_ADMIN],
  "company.reports": [PRACTICE_ADMIN, PRACTICE_FINANCE, DAO_FINANCE, DAO_ADMIN],
  "company.summary": [PRACTICE_ADMIN, PRACTICE_FINANCE, DAO_FINANCE, DAO_ADMIN],
  "company.members.read": [
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.members.create": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.members.update": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.members.delete": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.members.single": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.departments.read": [
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.departments.create": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.departments.update": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.departments.delete": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.departments.single": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    COMPANY_ADMIN
  ],
  "company.connections.accounting": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    DAO_FINANCE,
    COMPANY_ADMIN
  ],
  "company.connections.bank-reconciliation": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    DAO_FINANCE,
    COMPANY_ADMIN
  ],
  "company.connections.email": [COMPANY_USER, DAO_USER, COMPANY_ADMIN],
  "company.connections.comms": [COMPANY_USER, DAO_USER, COMPANY_ADMIN],
  "company.connections.invite": [PRACTICE_ADMIN, COMPANY_ADMIN, DAO_ADMIN],
  "company.csv-statements": [
    SUPER_ADMIN,
    PRACTICE_ADMIN,
    PRACTICE_FINANCE,
    DAO_ADMIN,
    DAO_FINANCE,
    COMPANY_ADMIN
  ]
};

export type Permission = keyof typeof Permissions;
